import React, { useEffect, useState } from "react";
import { Divider, Grid, Modal } from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import FilterModalHeaderSection from "./FilterModalHeaderSection";
import FilterModalDateSection from "./FilterModalDateSection";
import FilterModalTextSection from "./FilterModalTextSection";
import { Fragment } from "react";

const FilterModalComponent = ({
  modalOpen,
  handleClose,
  data,
  handleFilter,
  resetFilter,
}) => {
  const [draftFilters, setDraftFilters] = useState(
    data.map((item) => ({
      ...item,
      draftOptions: item.mainOptions,
    }))
  );

  const [loading, setLoading] = useState(false);
  const [applyFilter, setApplyFilter] = useState(false);
  // const [dateOptions, setDateOptions] = useState([
  //   { label: "All", selected: true },
  //   { label: "Today", selected: false },
  //   { label: "Past Week", selected: false },
  //   { label: "Last 30 Days", selected: false },
  //   { label: "Last 12 Months", selected: false },
  //   { label: "Enter a Range", selected: false },
  // ]);

  useEffect(() => {
    setDraftFilters(
      data.map((item) => ({
        ...item,
        draftOptions: item.mainOptions,
      }))
    );
  }, [data]);

  // useEffect(() => {
  //   const applyFilters = async () => {
  //     if (applyFilter) {
  //       setLoading(true);
  //       // Here we ensure the global state is updated before filtering
  //       draftFilters.forEach((item) => {
  //         item.setMainOptions(item.draftOptions);
  //       });
  //       if (handleFilter) {
  //         await handleFilter();
  //       }
  //       setLoading(false);
  //       setApplyFilter(false); // Reset the trigger
  //     }
  //   };
  //   applyFilters();
  // }, [applyFilter, draftFilters, handleFilter]);

  const handleApplyFilter = async () => {
    setApplyFilter(true);
    setLoading(true);
    draftFilters.forEach((item) => {
      item.setMainOptions(item.draftOptions);
    });
    // After state is updated, then call the filter handler
    if (handleFilter) {
      await handleFilter();
    }
    setLoading(false);
  };
  return (
    <Modal open={modalOpen} onClose={handleClose} sx={{zIndex: 5000}}>
      <Box sx={filterModalStyles}>
        <Grid container direction={"column"}>
          {/*close icon section*/}
          <Grid container justifyContent={"flex-end"}>
            <CloseIcon
              onClick={handleClose}
              style={{ cursor: "pointer", marginTop: 16 }}
            />
          </Grid>
          {/*Top Header section (Reset, Filter, apply Button)*/}
          <FilterModalHeaderSection
            // handleFilter={async () => {
            //   setLoading(true);
            //   await handleFilter();
            //   setLoading(false);
            // }}
            // handleFilter={handleFilter}
            handleFilter={handleApplyFilter}
            resetFilter={() => {
              resetFilter();
              // setDateOptions([
              //   { label: "All", selected: true },
              //   { label: "Today", selected: false },
              //   { label: "Past Week", selected: false },
              //   { label: "Last 30 Days", selected: false },
              //   { label: "Last 12 Months", selected: false },
              //   { label: "Enter a Range", selected: false },
              // ]);
            }}
            loading={loading}
          />
          <Divider style={dividerStyles} />
          {draftFilters &&
            draftFilters.map((item, index) =>
              item.type === "date" ? (
                <Fragment key={index}>
                  <FilterModalDateSection
                    // filterOptions={item.mainOptions}
                    // setFilterOptions={item.setMainOptions}
                    // options={dateOptions}
                    // setOptions={setDateOptions}
                    filterOptions={item.draftOptions}
                    setFilterOptions={(newOptions) => {
                      const newDraft = [...draftFilters];
                      newDraft[index].draftOptions = newOptions;
                      setDraftFilters(newDraft);
                    }}
                    currentOptions={item?.currentOptions}
                    // filterOptions={item.mainOptions}
                    // setFilterOptions={item.setMainOptions}
                    title={item.title}
                  />
                  <Divider style={dividerStyles} />
                </Fragment>
              ) : (
                <Fragment key={index}>
                  <FilterModalTextSection
                    // filterOptions={item.mainOptions}
                    // setFilterOptions={item.setMainOptions}
                    filterOptions={item.draftOptions}
                    setFilterOptions={(newOptions) => {
                      const newDraft = [...draftFilters];
                      newDraft[index].draftOptions = newOptions;
                      setDraftFilters(newDraft);
                    }}
                    title={item.title}
                    currentOptions={item.currentOptions}
                  />
                  <Divider style={dividerStyles} />
                </Fragment>
              )
            )}
        </Grid>
      </Box>
    </Modal>
  );
};

export default FilterModalComponent;

const dividerStyles = {
  width: "99%",
  backgroundColor: "#808080",
  marginTop: 16,
  marginBottom: 32,
  padding: "0.4px",
  marginLeft: 10,
};

const filterModalStyles = {
  position: "absolute",
  right: "0%",
  bgcolor: "#fff",
  p: 1.6,
  width: 500,
  height: "100vh",
};
